import { render, staticRenderFns } from "./shopCollection.vue?vue&type=template&id=b83d68ca&"
import script from "./shopCollection.vue?vue&type=script&lang=ts&"
export * from "./shopCollection.vue?vue&type=script&lang=ts&"
import style0 from "./shopCollection.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports